module.exports = __webpack_public_path__ + "static/media/step3.eb73f8fb.webp";